import { CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import {
  StringValue3s88kmb638dp as StringValue,
  ByteValue268mu8q8ola7t as ByteValue,
  ClassValue30nwdpwsxtf64 as ClassValue,
  SerializableAnnotation24zw55nlaus9i as SerializableAnnotation,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/VirtualType.mjs';
import { titleCase1rwupo9lkd0x6 as titleCase } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/casing.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_serializableProperties1162nosnaangd as get_serializableProperties,
  SerializableProperty3cbm268cpjr8q as SerializableProperty,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  FieldVisibility_EDIT_getInstancek1g4gozfl4h as FieldVisibility_EDIT_getInstance,
  FieldVisibility_HIDDEN_getInstance2bb3agz7xywku as FieldVisibility_HIDDEN_getInstance,
  get_descriptionegeezwg3tsc8 as get_description,
} from './Annotations.mjs';
import { firstOrNull1gk7vzkf4h3nq as firstOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  singleo93pzdgfc557 as single,
  firstOrNullf6vlo6vdgu1e as firstOrNull_0,
  plus20p0vtfmu0596 as plus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Companion_getInstance23x6zslwzj0st as Companion_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  weight31wqab1913ly4 as weight,
  textPopover3tarprbgmgxbr as textPopover,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import {
  h42yee57ysxgrns as h4,
  text189ciz0cnr32o as text,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  contains3ue2qo8xhmpf1 as contains,
  substringBefore3n7kj60w69hju as substringBefore,
  isBlank1dvkhjjvox3p0 as isBlank,
  substringAfter1hku067gwr5ve as substringAfter,
  removePrefix279df90bhrqqg as removePrefix,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerObject(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, VOID, CLASS_getInstance()), DataClassRenderer_instance);
}
function get_displayName(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = _this__u8e3s4.get_serializableAnnotations_8l2ro_k$();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.fqn_1 === 'com.lightningkite.services.data.DisplayName') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.values_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_wei43m_k$('text');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp2_safe_receiver instanceof StringValue() ? tmp2_safe_receiver : null;
  }
  var tmp3_safe_receiver = tmp;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.value_1;
  return tmp4_elvis_lhs == null ? _this__u8e3s4.get_name_woqyms_k$() === '_id' ? 'ID' : titleCase(_this__u8e3s4.get_name_woqyms_k$()) : tmp4_elvis_lhs;
}
var DataClassRendererClass;
function DataClassRenderer() {
  if (DataClassRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Fields';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_28tizu_k$(context, module_0) {
        var descriptor = context.serializer_1.get_descriptor_wjt6a0_k$();
        if (!equals(descriptor.get_kind_wop7ml_k$(), CLASS_getInstance()))
          return -1.0;
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = get_serializableProperties(context.serializer_1);
        var tmp;
        if (this_0 == null) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.isEmpty' call
          tmp = this_0.length === 0;
        }
        if (tmp)
          return -1.0;
        return 0.6;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_28tizu_k$(context, module_0);
      }
      form_klw3k6_k$(context, value, module_0) {
        var rows = fieldRows(context, module_0);
        return (_this__u8e3s4) => {
          renderRows(_this__u8e3s4, rows, ($this$renderRows, field) => {
            var tmp;
            if (fieldVisibility(field.property_1, module_0).equals(FieldVisibility_EDIT_getInstance())) {
              renderFieldForm($this$renderRows, field, value, module_0);
              tmp = Unit_instance;
            } else {
              renderFieldView($this$renderRows, field, value, module_0);
              tmp = Unit_instance;
            }
            return Unit_instance;
          });
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_klw3k6_k$(context, value, module_0);
      }
      view_3m91zp_k$(context, value, module_0) {
        var rows = fieldRows(context, module_0);
        return (_this__u8e3s4) => {
          renderRows(_this__u8e3s4, rows, ($this$renderRows, field) => {
            renderFieldView($this$renderRows, field, value, module_0);
            return Unit_instance;
          });
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_3m91zp_k$(context, value, module_0);
      }
      cellView_hcodjr_k$(context, value, module_0) {
        var properties = get_serializableProperties(context.serializer_1);
        var tmp;
        if (properties == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$3;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable = 0;
            var last = properties.length;
            while (inductionVariable < last) {
              var element = properties[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              if (element.get_name_woqyms_k$() === 'name') {
                tmp$ret$3 = element;
                break $l$block;
              }
            }
            tmp$ret$3 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$3;
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.collections.find' call
            var tmp$ret$6;
            $l$block_0: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var inductionVariable_0 = 0;
              var last_0 = properties.length;
              while (inductionVariable_0 < last_0) {
                var element_0 = properties[inductionVariable_0];
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                if (element_0.get_name_woqyms_k$() === 'title') {
                  tmp$ret$6 = element_0;
                  break $l$block_0;
                }
              }
              tmp$ret$6 = null;
            }
            tmp_0 = tmp$ret$6;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var tmp1_elvis_lhs = tmp_0;
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            // Inline function 'kotlin.collections.find' call
            var tmp$ret$9;
            $l$block_1: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var inductionVariable_1 = 0;
              var last_1 = properties.length;
              while (inductionVariable_1 < last_1) {
                var element_1 = properties[inductionVariable_1];
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                if (element_1.get_name_woqyms_k$() === 'subject') {
                  tmp$ret$9 = element_1;
                  break $l$block_1;
                }
              }
              tmp$ret$9 = null;
            }
            tmp_1 = tmp$ret$9;
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          var tmp2_elvis_lhs = tmp_1;
          var tmp_2;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.collections.find' call
            var tmp$ret$12;
            $l$block_2: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var inductionVariable_2 = 0;
              var last_2 = properties.length;
              while (inductionVariable_2 < last_2) {
                var element_2 = properties[inductionVariable_2];
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                if (element_2.get_name_woqyms_k$() === 'label') {
                  tmp$ret$12 = element_2;
                  break $l$block_2;
                }
              }
              tmp$ret$12 = null;
            }
            tmp_2 = tmp$ret$12;
          } else {
            tmp_2 = tmp2_elvis_lhs;
          }
          var tmp3_elvis_lhs = tmp_2;
          tmp = tmp3_elvis_lhs == null ? firstOrNull(properties) : tmp3_elvis_lhs;
        }
        var tmp1_elvis_lhs_0 = tmp;
        var tmp_3;
        if (tmp1_elvis_lhs_0 == null) {
          return (_this__u8e3s4) => {
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
            ensureOutermostElement(element);
            _this__u8e3s4.willAddChild_hz2iwc_k$(element);
            var tmp = KMutableProperty0();
            var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
            var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
            element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => toString($this$invoke.invoke_r7m7el_k$(value)));
            element.onStartup_vrxh3i_k$();
            _this__u8e3s4.addChild_2qpft2_k$(element);
            return Unit_instance;
          };
        } else {
          tmp_3 = tmp1_elvis_lhs_0;
        }
        var titleProp = tmp_3;
        var field = asField(titleProp, context.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), module_0);
        return (_this__u8e3s4) => {
          module_0.cellView_ngep41_k$(field.context_1, lens(value, (it) => field.property_1.get_g4cbzo_k$(it)))(_this__u8e3s4);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_hcodjr_k$(context, value, module_0);
      }
      columnWidth_g6s04q_k$(context, module_0) {
        return 20.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_g6s04q_k$(context, module_0);
      }
      labeledForm_2wlxsw_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          sectionHeader(element, label, description);
          DataClassRenderer_instance.form_klw3k6_k$(context, value, module_0)(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_2wlxsw_k$(context, value, module_0, label, description);
      }
      labeledView_93udid_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          sectionHeader(element, label, description);
          DataClassRenderer_instance.view_3m91zp_k$(context, value, module_0)(element);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_93udid_k$(context, value, module_0, label, description);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    initMetadataForObject($, 'DataClassRenderer', VOID, VOID, [Renderer()]);
    DataClassRendererClass = $;
  }
  return DataClassRendererClass;
}
var DataClassRenderer_instance;
function DataClassRenderer_getInstance() {
  return DataClassRenderer_instance;
}
var FieldClass;
function Field() {
  if (FieldClass === VOID) {
    class $ {
      constructor(property, context, width) {
        this.property_1 = property;
        this.context_1 = context;
        this.width_1 = width;
      }
    }
    initMetadataForClass($, 'Field');
    FieldClass = $;
  }
  return FieldClass;
}
function fieldRows(context, module_0) {
  var ownerSerialName = context.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp0_elvis_lhs = get_serializableProperties(context.serializer_1);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp = [];
  } else {
    tmp = tmp0_elvis_lhs;
  }
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var inductionVariable = 0;
  var last = tmp0.length;
  while (inductionVariable < last) {
    var element = tmp0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (!fieldVisibility(element, module_0).equals(FieldVisibility_HIDDEN_getInstance())) {
      destination.add_utx5q5_k$(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = fieldRows$lambda;
  var tmp$ret$6 = new (sam$kotlin_Comparator$0())(tmp_0);
  // Inline function 'kotlin.collections.map' call
  var this_0 = sortedWith(destination, tmp$ret$6);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$9 = asField(item, ownerSerialName, module_0);
    destination_0.add_utx5q5_k$(tmp$ret$9);
  }
  var fields = destination_0;
  if (fields.isEmpty_y1axqb_k$())
    return emptyList();
  var tmp_1;
  var tmp$ret$10;
  $l$block_0: {
    // Inline function 'kotlin.collections.none' call
    var tmp_2;
    if (isInterface(fields, Collection())) {
      tmp_2 = fields.isEmpty_y1axqb_k$();
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp$ret$10 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s_0 = fields.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
      if (!(get_group(element_0.property_1) == null)) {
        tmp$ret$10 = false;
        break $l$block_0;
      }
    }
    tmp$ret$10 = true;
  }
  if (tmp$ret$10) {
    tmp_1 = fitsInOneRow(fields);
  } else {
    tmp_1 = false;
  }
  if (tmp_1)
    return listOf(fields);
  // Inline function 'kotlin.collections.mutableListOf' call
  var rows = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  // Inline function 'kotlin.collections.mutableSetOf' call
  var emittedGroups = LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$();
  var _iterator__ex2g4s_1 = fields.iterator_jk1svi_k$();
  $l$loop_0: while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
    var field = _iterator__ex2g4s_1.next_20eer_k$();
    var groupName = get_group(field.property_1);
    if (groupName == null) {
      rows.add_utx5q5_k$(listOf(field));
      continue $l$loop_0;
    }
    if (!emittedGroups.add_utx5q5_k$(groupName))
      continue $l$loop_0;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s_2 = fields.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
      var element_1 = _iterator__ex2g4s_2.next_20eer_k$();
      if (get_group(element_1.property_1) == groupName) {
        destination_1.add_utx5q5_k$(element_1);
      }
    }
    var members = destination_1;
    if (fitsInOneRow(members))
      rows.add_utx5q5_k$(members);
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_3 = members.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
        var element_2 = _iterator__ex2g4s_3.next_20eer_k$();
        rows.add_utx5q5_k$(listOf(element_2));
      }
    }
  }
  return rows;
}
function renderRows(_this__u8e3s4, rows, renderField) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  var _iterator__ex2g4s = rows.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var fieldRow = _iterator__ex2g4s.next_20eer_k$();
    if (fieldRow.get_size_woubt6_k$() === 1) {
      renderField(element, single(fieldRow));
    } else {
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var _iterator__ex2g4s_0 = fieldRow.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
        var tmp = sum;
        sum = tmp + element_0.width_1;
      }
      var tmp$ret$4 = sum;
      // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
      var breakpoint = get_rem(tmp$ret$4 + 10.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (RowCollapsingToColumn())(element.get_context_h02k06_k$(), listOf(new (Dimension())(breakpoint)));
      ensureOutermostElement(element_1);
      element.willAddChild_hz2iwc_k$(element_1);
      var _iterator__ex2g4s_1 = fieldRow.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
        var field = _iterator__ex2g4s_1.next_20eer_k$();
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_0 = weight(element_1, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_0.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        renderField(element_2, field);
        element_2.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element_2);
      }
      element_1.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_1);
    }
  }
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
}
function fieldVisibility(_this__u8e3s4, module_0) {
  var tmp = _this__u8e3s4.get_serializer_u29zhh_k$();
  var context = new (RenderContext())(isInterface(tmp, KSerializer()) ? tmp : THROW_CCE(), _this__u8e3s4.get_serializableAnnotations_8l2ro_k$());
  return module_0.effectiveVisibility_ilul0q_k$(context);
}
function renderFieldForm(_this__u8e3s4, field, parentValue, module_0) {
  var property = field.property_1;
  var tmp = (it) => property.get_g4cbzo_k$(it);
  var fieldValue = parentValue.lens_u4wb4z_k$(tmp, (parent, newFieldValue) => property.setCopy_8a6bik_k$(parent, newFieldValue));
  var sentenceText = get_sentence(property);
  if (get_doesNotNeedLabel(property))
    module_0.form_gqhwsi_k$(field.context_1, fieldValue)(_this__u8e3s4);
  else if (!(sentenceText == null)) {
    withSentence(_this__u8e3s4, sentenceText, ($this$withSentence) => {
      module_0.form_gqhwsi_k$(field.context_1, fieldValue)($this$withSentence);
      return Unit_instance;
    });
  } else
    module_0.labeledFormWithSwitcher_1jpbbj_k$(field.context_1, fieldValue, get_displayName(property), get_description(property))(_this__u8e3s4);
}
function renderFieldView(_this__u8e3s4, field, parentValue, module_0) {
  var property = field.property_1;
  var fieldValue = lens(parentValue, (it) => property.get_g4cbzo_k$(it));
  var sentenceText = get_sentence(property);
  if (get_doesNotNeedLabel(property))
    module_0.view_ntgxjz_k$(field.context_1, fieldValue)(_this__u8e3s4);
  else if (!(sentenceText == null)) {
    withSentence(_this__u8e3s4, sentenceText, ($this$withSentence) => {
      module_0.view_ntgxjz_k$(field.context_1, fieldValue)($this$withSentence);
      return Unit_instance;
    });
  } else
    module_0.labeledViewWithSwitcher_k209xo_k$(field.context_1, fieldValue, get_displayName(property), get_description(property))(_this__u8e3s4);
}
function asField(_this__u8e3s4, ownerSerialName, module_0) {
  var property = isInterface(_this__u8e3s4, SerializableProperty()) ? _this__u8e3s4 : THROW_CCE();
  var context = new (RenderContext())(property.get_serializer_u29zhh_k$(), serializableAnnotationsWithPkAnnotationIfId(property, ownerSerialName));
  var tmp0_elvis_lhs = module_0.columnWidth_g5mvjx_k$(context);
  return new (Field())(property, context, tmp0_elvis_lhs == null ? 10.0 : tmp0_elvis_lhs);
}
function sectionHeader(_this__u8e3s4, label, description) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  h4(element, label);
  if (description == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0 = textPopover(get_centered(element), description);
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    var icon = Companion_getInstance().info_1.copy$default_cqy5mq_k$(get_rem_0(1), get_rem_0(1));
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (IconView())(tmp0.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    tmp0.willAddChild_hz2iwc_k$(element_0);
    element_0.set_source_3o5lkf_k$(icon);
    element_0.set_description_s1386w_k$('Info');
    element_0.onStartup_vrxh3i_k$();
    tmp0.addChild_2qpft2_k$(element_0);
  }
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
}
function get_importance(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = _this__u8e3s4.get_serializableAnnotations_8l2ro_k$();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.fqn_1 === 'com.lightningkite.services.data.Importance') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.values_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_values_ksazhn_k$();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : firstOrNull_0(tmp2_safe_receiver);
  var tmp;
  if (tmp3_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp3_safe_receiver instanceof ByteValue() ? tmp3_safe_receiver : null;
  }
  var tmp4_safe_receiver = tmp;
  var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.value_1;
  var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver;
  var tmp_0;
  if (tmp6_elvis_lhs == null) {
    switch (_this__u8e3s4.get_name_woqyms_k$()) {
      case '_id':
        tmp_0 = contains(_this__u8e3s4.get_serializer_u29zhh_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), 'Uuid') ? 8 : 1;
        break;
      case 'title':
      case 'subject':
        tmp_0 = 1;
        break;
      case 'name':
      case 'email':
      case 'phone':
        tmp_0 = 2;
        break;
      default:
        tmp_0 = 7;
        break;
    }
  } else {
    tmp_0 = tmp6_elvis_lhs;
  }
  return tmp_0;
}
function get_group(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = _this__u8e3s4.get_serializableAnnotations_8l2ro_k$();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.fqn_1 === 'com.lightningkite.services.data.Group') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.values_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_values_ksazhn_k$();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : firstOrNull_0(tmp2_safe_receiver);
  var tmp;
  if (tmp3_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp3_safe_receiver instanceof StringValue() ? tmp3_safe_receiver : null;
  }
  var tmp4_safe_receiver = tmp;
  return tmp4_safe_receiver == null ? null : tmp4_safe_receiver.value_1;
}
function fitsInOneRow(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.get_size_woubt6_k$() <= 4) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp_0 = sum;
      sum = tmp_0 + element.width_1;
    }
    tmp = sum <= 50.0;
  } else {
    tmp = false;
  }
  return tmp;
}
function get_sentence(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = _this__u8e3s4.get_serializableAnnotations_8l2ro_k$();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.fqn_1 === 'com.lightningkite.services.data.Sentence') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.values_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_values_ksazhn_k$();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : firstOrNull_0(tmp2_safe_receiver);
  var tmp;
  if (tmp3_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp3_safe_receiver instanceof StringValue() ? tmp3_safe_receiver : null;
  }
  var tmp4_safe_receiver = tmp;
  return tmp4_safe_receiver == null ? null : tmp4_safe_receiver.value_1;
}
function get_doesNotNeedLabel(_this__u8e3s4) {
  var tmp0 = _this__u8e3s4.get_serializableAnnotations_8l2ro_k$();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.isEmpty_y1axqb_k$();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (element.fqn_1 === 'com.lightningkite.services.data.DoesNotNeedLabel') {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function withSentence(_this__u8e3s4, sentence, control) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'kotlin.takeIf' call
  var this_0 = substringBefore(sentence, _Char___init__impl__6a9atx(95));
  var tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  if (!isBlank(this_0)) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    text(element, tmp0_safe_receiver);
  }
  control(element);
  // Inline function 'kotlin.takeIf' call
  var this_1 = removePrefix(substringAfter(sentence, _Char___init__impl__6a9atx(95)), '_');
  var tmp_0;
  // Inline function 'kotlin.text.isNotBlank' call
  if (!isBlank(this_1)) {
    tmp_0 = this_1;
  } else {
    tmp_0 = null;
  }
  var tmp1_safe_receiver = tmp_0;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    text(element, tmp1_safe_receiver);
  }
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
}
function serializableAnnotationsWithPkAnnotationIfId(_this__u8e3s4, fqn) {
  var tmp;
  var tmp_0;
  if (_this__u8e3s4.get_name_woqyms_k$() === '_id') {
    var tmp0 = _this__u8e3s4.get_serializableAnnotations_8l2ro_k$();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_1;
      if (isInterface(tmp0, Collection())) {
        tmp_1 = tmp0.isEmpty_y1axqb_k$();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        var tmp_2;
        if (element.fqn_1 === 'com.lightningkite.services.data.References') {
          var tmp_3 = element.values_1.get_wei43m_k$('references');
          var tmp0_safe_receiver = tmp_3 instanceof ClassValue() ? tmp_3 : null;
          tmp_2 = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fqn_1) === fqn;
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp_0 = tmp$ret$0;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp_4 = _this__u8e3s4.get_serializableAnnotations_8l2ro_k$();
    // Inline function 'kotlin.collections.mapOf' call
    var tmp$ret$2 = emptyMap();
    tmp = plus(tmp_4, new (SerializableAnnotation())('com.lightningkite.kiteui.forms.IsPrimaryKey', tmp$ret$2));
  } else {
    tmp = _this__u8e3s4.get_serializableAnnotations_8l2ro_k$();
  }
  return tmp;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function fieldRows$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = get_importance(a);
  var tmp$ret$2 = get_importance(b);
  return compareValues(tmp, tmp$ret$2);
}
//region block: init
DataClassRenderer_instance = new (DataClassRenderer())();
//endregion
//region block: exports
export {
  get_displayName as get_displayName3v1e4ru2it5uv,
  get_importance as get_importance2ftcvro0528ce,
  registerObject as registerObject1ttoxtvhwoaoe,
};
//endregion

//# sourceMappingURL=DataClassRenderer.mjs.map
